<script setup lang="ts">
import BaseDropdown from '@/components/base/BaseDropdown.vue'
import { useI18n } from 'vue-i18n'

defineOptions({
  name: 'ProfileSummary'
})

const { t } = useI18n()
</script>

<template>
  <BaseDropdown id="user-menu">
    <template #button="{ toggle, open }">
      <button
        id="user-menu"
        type="button"
        class="flex max-w-xs items-center justify-center rounded-full fill-current text-sm focus:shadow-outline focus:outline-hidden"
        aria-label="User menu"
        aria-haspopup="true"
        :aria-expanded="`${open}`"
        @click="toggle"
      >
        <span
          class="flex items-center overflow-hidden rounded-full border-2 border-primary fill-current text-primary"
        >
          <VIcon
            icon="$account-outline"
            class="rounded-full bg-white text-primary"
            size="1.75rem"
          />
        </span>
      </button>
    </template>
    <template #default>
      <RouterLink
        :to="{ name: 'settings' }"
        class="block w-full px-4 py-2 text-left text-lg transition duration-150 ease-in-out hover:bg-secondary-100 md:text-sm"
        role="menuitem"
      >
        {{ t('general.my_account') }}
      </RouterLink>
      <button
        type="button"
        class="block w-full px-4 py-2 text-left text-lg transition duration-150 ease-in-out hover:bg-secondary-100 md:text-sm"
        role="menuitem"
        @click="$store.dispatch('auth/logout')"
      >
        {{ t('general.sign_out') }}
      </button>
    </template>
  </BaseDropdown>
</template>
